import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TABS, ActiveTab } from '@/lib/report/report.types';

/**
 * Report workflow state stored in Redux.
 * NOTE: Keep server payloads out of this slice; use React Query for report data.
 */
export interface ReportState {
  activeTab: ActiveTab;
}

const initialState: ReportState = {
  activeTab: TABS.topup,
};

const reportSlice = createSlice({
  name: 'reportSlice',
  initialState,
  reducers: {
    setActiveTab: (_state, action: PayloadAction<ActiveTab>): ReportState => ({
      // Explicitly return workflow-only shape to avoid carrying accidental keys.
      activeTab: action.payload,
    }),
  },
});

export const { setActiveTab } = reportSlice.actions;

export default reportSlice.reducer;
